export class ApiError extends Error {
  /**
   * @param {object} args
   * @param {string} args.operation
   * @param {string} args.kind
   * @param {number | null} [args.status]
   * @param {string} [args.serverMessage]
   * @param {string} [args.url]
   * @param {string} [args.method]
   * @param {any} [args.responseBody]
   * @param {boolean} [args.retryable]
   * @param {unknown} [args.cause]
   */
  constructor({
    operation,
    kind,
    status = null,
    serverMessage = '',
    url = '',
    method = '',
    responseBody = null,
    retryable = false,
    cause,
  }) {
    super(serverMessage || 'Request failed');
    this.name = 'ApiError';

    this.operation = operation;
    this.kind = kind;
    this.status = status;
    this.serverMessage = serverMessage || '';
    this.url = url || '';
    this.method = method || '';
    this.responseBody = responseBody ?? null;
    this.retryable = Boolean(retryable);
    this.cause = cause;
  }
}

export const ApiErrorKind = Object.freeze({
  Network: 'Network',
  Unauthorized: 'Unauthorized',
  NotFound: 'NotFound',
  Validation: 'Validation',
  Conflict: 'Conflict',
  Server: 'Server',
  Unknown: 'Unknown',
});

export function isApiError(err) {
  return Boolean(err && typeof err === 'object' && err.name === 'ApiError');
}

